// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_927a99ad28--wrapper--BYLaw","switcher":"_927a99ad28--switcher--HMXig","hint":"_927a99ad28--hint--Bp3tH"};